import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Placeholder from '../../../components/Placeholder';
import ContentfulImage from '../../../components/ContentfulImage';

import getStylistToolContent from '../../../redux/actions/stylistTool';
import { retrieveDiagnosisProfile, makeUserCurrent } from '../../../redux/actions/hairDiagnosis';
import { getCurrentDiagnosisUser, getAllDiagnosisUsers } from '../../../redux/selectors/hairDiagnosis';

import {
  Button,
  Content,
  ContentSection,
  ImageContainer,
  Input,
  Subtext,
  SubtextPlaceholder,
  Title,
  Wrapper,
  Spinner,
} from './RetrieveProfile.style';

class RetrieveProfilePage extends Component {
  state = {
    email: '',
    error: false,
    loading: false,
  };

  componentDidMount() {
    const { currentDiagnosisUser, history, locale, stylistTool, getStylistToolContent } = this.props;

    if (currentDiagnosisUser) {
      history.push(`/${locale}/stylist/profile`);
    }

    if (!stylistTool.profileHairProfileImage) {
      getStylistToolContent(locale);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { currentDiagnosisUser, history, locale } = nextProps;

    if (!this.props.currentDiagnosisUser && currentDiagnosisUser) {
      history.push(`/${locale}/stylist/profile`);
    }
  }

  handleRetrieveProfile = ev => {
    ev.preventDefault();
    const { locale, users, retrieveDiagnosisProfile, history, makeUserCurrent } = this.props;
    const existingUser = users.find(user => user.email === this.state.email);

    const { email } = this.state;
    this.setState(
      {
        error: false,
        loading: true,
      },
      () => {
        if (existingUser) {
          makeUserCurrent(existingUser.id);
          history.push(`/${locale}/stylist/profile`);
        } else {
          retrieveDiagnosisProfile(this.state.email).catch(() => {
            this.setState({
              error: true,
              loading: false,
              email: '',
            });
          });
        }
      }
    );
  };

  handleEmailChange = ev => {
    this.setState({
      email: ev.target.value,
      error: false,
    });
  };

  isEmailValid = () => {
    const { email } = this.state;

    return email.toLowerCase().match(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line
    );
  };

  render() {
    const { copy, stylistTool } = this.props;
    const { email, error, loading } = this.state;
    return (
      <Wrapper>
        {stylistTool.retrieveProfileImage ? (
          <ImageContainer>
            <ContentfulImage
              src={stylistTool.retrieveProfileImage}
              options={{
                size: 320,
                objectFit: 'cover',
                objectPosition: 'top',
                w: '100%',
                h: '100%',
              }}
            />
          </ImageContainer>
        ) : (
          <div style={{ flex: 1 }} />
        )}
        <ContentSection>
          <Content>
            {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
              <div>
                <Title>{copy.retrieve}</Title>
                <Title>{copy.customer_profile}</Title>
              </div>
            ) : (
              <div>
                <Placeholder h="80px" w="80%" />
              </div>
            )}
            <form onSubmit={this.handleRetrieveProfile}>
              <Input
                type="email"
                placeholder={copy.email_placeholder}
                value={email}
                onChange={this.handleEmailChange}
              />
              {error && <p style={{ fontSize: '14px', color: 'red' }}>{copy.error_occurred}</p>}
              {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
                <Button type="submit" disabled={!this.isEmailValid() || loading}>
                  {loading ? <Spinner /> : copy.retrieve}
                </Button>
              ) : (
                <div>
                  <Placeholder h="65px" w="250px" />
                </div>
              )}
              {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
                <Subtext>{copy.subtext}</Subtext>
              ) : (
                <SubtextPlaceholder>
                  <Placeholder h="65px" w="250px" />
                </SubtextPlaceholder>
              )}
            </form>
          </Content>
        </ContentSection>
      </Wrapper>
    );
  }
}

RetrieveProfilePage.defaultProps = {
  copy: {},
  currentDiagnosisUser: null,
  users: [],
};

RetrieveProfilePage.propTypes = {
  locale: PropTypes.string.isRequired,
  copy: PropTypes.shape({}),
  retrieveDiagnosisProfile: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  currentDiagnosisUser: PropTypes.shape({}),
  users: PropTypes.arrayOf(PropTypes.shape()),
  makeUserCurrent: PropTypes.func.isRequired,
  stylistTool: PropTypes.shape().isRequired,
  getStylistToolContent: PropTypes.func.isRequired,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyStylistToolRetrievePage,
  locale: state.locale,
  currentDiagnosisUser: getCurrentDiagnosisUser(state),
  users: getAllDiagnosisUsers(state),
  stylistTool: state.stylistTool,
  stylist: state.user,
  auth: state.auth,
});

const mapDispatch = dispatch => ({
  retrieveDiagnosisProfile: email => dispatch(retrieveDiagnosisProfile(email)),
  makeUserCurrent: id => dispatch(makeUserCurrent(id)),
  getStylistToolContent: locale => dispatch(getStylistToolContent(locale)),
});

export default connect(mapState, mapDispatch)(RetrieveProfilePage);



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/RetrieveProfilePage/RetrieveProfilePage.js